/**
 * @ Author: DY
 * @ Date: 2023-11-02 12:00:18
 * @ LastEditTime: 2025-03-06 14:23:33
 * @ Description:
 * @ FilePath: \ShiMo_Mobile\src\assets\mixin\mixin_list.js
 */
import { HeaderNav } from '@/components/';
export const mixin_list = {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backPathName = from.name;
        });
    },
    components: {
        HeaderNav,
    },
    data() {
        return {
            backPathName: '',
            cacheKey: '',
            searchKey: 'searchKey',
            keyVal: '',
            isLoading: false,
            isUpLoading: false,
            finished: false,
            requestUrl: '/basicplatform/tabledata',
            initIndex: 0,
            pageIndex: 0,
            pageSize: 3,
            indexKey: 'page',
            sizeKey: 'limit',
            listData: [],
            tableCode: '',
        };
    },
    filters: {},
    created() { },
    mounted() { },
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'home' });
        },
        async initPage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const requestData = this.loadRequestData();
            const res = await this.getListData(this.requestUrl, requestData);
            if (requestData[this.indexKey] === this.initIndex) {
                this.listData = res.rows;
            } else {
                this.listData.push(...res.rows);
            }
            if (res.total <= this.listData.length) {
                this.finished = true;
            }
            this.isLoading = false;
            this.isUpLoading = false;
            this.$toast.clear();
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                [this.searchKey]: this.keyVal,
            };
        },
        // 下拉刷新
        onRefresh() {
            this.pageIndex = this.initIndex;
            this.listData = [];
            this.isLoading = false;
            this.finished = false;
            this.initPage();
        },
        onLoad() {
            this.initPage();
            this.pageIndex++;
        },
        getListData(requestUrl, requestData) {
            return this.$axios.$post(`/interfaceApi${requestUrl}`, requestData, { defEx: true });
        },
    },
};
